/** Public podcast/social invite: /:companySlug/invitacion/:inviteToken */
export function isPodcastInvitePath(pathname: string): boolean {
  return /^\/[^/]+\/invitacion\/[^/]+$/.test(pathname);
}

/** Public collection / sponsor share links; no auth or product permissions required. */
export function isPublicSharePath(pathname: string): boolean {
  return (
    /^\/colecciones\/[^/]+$/.test(pathname) ||
    /^\/[^/]+\/[^/]+\/brands\/[^/]+$/.test(pathname)
  );
}
